import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.875 0.875L10.625 0.875L10.625 2.375L2.375 2.375L2.375 13.625L10.625 13.625L10.625 15.125L0.875 15.125L0.875 0.875ZM11.5035 4.06842L15.4355 8.0004L11.5035 11.9324L10.4429 10.8717L12.5646 8.75L5.32153 8.75L5.32153 7.25L12.5638 7.25L10.4429 5.12908L11.5035 4.06842Z"
      fill="white"
      fillOpacity={0.85}
    />
  </svg>
);
export default SVGComponent;
